import { render, staticRenderFns } from "./WikimediaExamples.vue?vue&type=template&id=001693bf&scoped=true"
import script from "./WikimediaExamples.vue?vue&type=script&lang=js"
export * from "./WikimediaExamples.vue?vue&type=script&lang=js"
import style0 from "./WikimediaExamples.vue?vue&type=style&index=0&id=001693bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001693bf",
  null
  
)

export default component.exports